"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useToken = useToken;
var _react = require("react");
var _tokenContext = require("./tokenContext");
function useToken() {
    return (0, _react.useContext)(_tokenContext.tokenContext);
} //# sourceMappingURL=useToken.js.map
